<template>

  <div>
    <treeselect
      :value="value"
      @input="changed($event)"
      :options="options"
      :multiple="true"
      :limit="1"
      :placeholder="$t('variables')"
      :clearAllText="$t('clear')"
      :noOptionsText="$t('variables.select-asset')"
      :limitText="(n) => $t('and-more', [n])"
    />
  </div>

</template>

<script>
  import { mapState } from 'vuex'
  import { translateVariableName } from '../../helpers/translation'

  const variableSeparator = '-'

  export default {
    name: 'variables-tree',

    props: [ 'value', 'assets', 'autoselect' ],

    data () {
      return {
        devices: [],
      }
    },

    computed: {
      ...mapState([
        'deviceDefinitions'
      ]),

      selectedAssetTypes () {
        return this.assets.reduce((types, { deviceType }) => {
          if (!types.includes(deviceType)) {
            types.push(deviceType)
          }
          return types
        }, [])
      },

      selectedAssetVariables () {
        const { deviceDefinitions } = this
        return this.assets.reduce((variables, { deviceType, enabledVariables }) => {
          if (!Array.isArray(deviceDefinitions[deviceType])) {
            return variables
          }
          deviceDefinitions[deviceType].forEach((variable) => {
            const name = deviceType + variableSeparator + variable
            const pass = !variables.includes(name) && (!enabledVariables || (enabledVariables && enabledVariables.includes(variable)))
            if (pass) {
              variables.push(name)
            }
          })
          return variables
        }, [])
      },

      options () {
        const result = []
        Object.entries(this.deviceDefinitions)
          .filter(([deviceType]) => this.selectedAssetTypes.includes(deviceType))
          .forEach(([deviceType, variables]) => {
            result.push({
              id: deviceType,
              label: deviceType,
              children: variables
                .filter((variable) => this.selectedAssetVariables.includes(deviceType + variableSeparator + variable))
                .map(variable => ({
                  id: deviceType + variableSeparator + variable,
                  label: translateVariableName(variable)
                }))
            })
          })
        return result
      },
    },

    methods: {
      changed (event) {
        const variables = []
        event.forEach(nodeId => {
          const variable = this.options.find(({ id }) => id === nodeId)
          if (variable) {
            // group of variables on the level of device type => add all variables within the group
            variables.push(...variable.children.map(({ id }) => id))
          } else {
            // single variable => add it
            variables.push(nodeId)
          }
        })

        this.$emit('input', event)
        this.$emit('variables', variables)
      },
    },

    watch: {
      assets () {
        if (this.autoselect)
          this.changed(this.options.map(({ id }) => id))
      }
    },

    async created () {
      this.devices = await this.$store.dispatch('getDeviceDefinitions')
    },
  }
</script>

<style scoped lang="scss">

</style>
